import { Link } from 'react-router-dom'
import { ActionBtn } from './ActionBtn'
import getLabelByValue from 'sr/helpers/functions/getLabelByValue'
import { MainWorkOrderStatus, WorkOrderStatus } from 'sr/i18n/messages/setting'
import { DateFormat } from 'sr/helpers/functions/DateFormat'
import { useAuth } from 'app/pages/module/auth'
export const TableRow = ({item, setEditId, setDeleteId, setShowDelete, deletePermission = false, isCompletionDate=false, type, editPermission, rejectPermission, active, activeType = null}) => {
const {userType} = useAuth()

  return (
    <>
        <tr className="bg-white border-b  hover:bg-gray-50">
          
            <th scope="row" className="px-6 py-4 font-medium text-gray-900 text-base">
            <Link to={`${userType==='company' ? item?.workorder_status==='scheduled' ? `/work-order-details/${item?.id}`:`/work-order-progress/${item?.id}` : `/supervisor/manage-work-order/${item?.id}` }`}>
            {item?.title}
           </Link>
            </th>
            <td className="px-6 py-4 font-medium text-gray-900 ">
                {item?.customer_id?.name}
            </td>
            <td className="px-6 py-4 w-[26rem]">
               {item?.customer_location_id?.address?.address_line_1} {item?.customer_location_id?.address?.address_line_2} {item?.customer_location_id?.address?.city}
            </td>
          {type === 'one time'  && <>

            <td className="px-6 py-4">
          {DateFormat(item?.one_time_date)}
            </td>
            {isCompletionDate &&
            <td className="px-6 py-4">
          {DateFormat(item?.completion_date)}
            </td>
}
            </>}
            <td className="px-6 py-4">
  ${Number(item?.pay_type_rate)?.toFixed(2)}
  </td>
            <td className="px-6 py-4 relative w-[10rem]">
           <p>{ getLabelByValue(item?.workorder_status, WorkOrderStatus)} </p>
           {item?.status==='draft' && <p className='absolute top-3 bg-[#ff39b3] font-bold rounded-xl text-white px-[0.3rem] -py-[0.2rem]  right-10'>{getLabelByValue(item?.status, MainWorkOrderStatus)} </p>
}
        
            </td>
            {((type ==='recurring') || (type==='one time' && (active==='scheduled'|| active==='in progress'|| (active==='rejected' && activeType==='contract')))) &&
            <td className="px-6 py-4">
         
            <ActionBtn rejectPermission={rejectPermission} deletePermission={deletePermission} editPermission={editPermission}  editonClick={()=> setEditId(item?.id)} rejectonClick={()=> {setShowDelete(true); setDeleteId(item?.id)}}/>
           
            </td>
}
        </tr>
  </>)
}
